import Heart from "./Heart";
import Word from "./Word";
import Restart from "./Restart";

import * as S from "./styles";

const Bottom = ({ currentWord, typingWord, health, hurting, onRestart }) => {
  const colorFor = (letter, i) => {
    const typed = typingWord[i];
    if (typed == null) return { color: "var(--text-faint)" };
    if (typed === letter) return { color: "var(--accent)", textShadow: "0 0 10px var(--accent-glow)" };
    return { color: "var(--danger)", textShadow: "0 0 10px var(--danger-glow)" };
  };

  return (
    <S.Bottom>
      <Heart health={health} hurting={hurting} />
      <Word colorFor={colorFor} currentWord={currentWord} />
      <Restart onRestart={onRestart} />
    </S.Bottom>
  );
};

export default Bottom;
